<template>
  <b-modal
    :id="id"
    :title="trans('invoice_items')"
    size="xl"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <p>
      {{ trans('microsite_modify_invoice_items') }}
    </p>
    <b-overlay :show="busy">
      <b-table
        id="admin-invoice-items"
        ref="table"
        class="bg-white mb-3"
        :items="items"
        :fields="fields"
        small
        responsive
        show-empty
      >
        <template v-slot:empty>
          <p class="lead text-center text-muted p-3">{{ trans('none') }}</p>
        </template>
        <template v-slot:cell(name)="data">
          <b-form-input
            v-model="data.item.name"
            size="sm"
            :disabled="busy"
          />
        </template>
        <template v-slot:cell(quantity)="data">
          <b-form-input
            v-if="data.item.quantity !== null"
            v-model="data.item.quantity"
            type="number"
            min="0"
            size="sm"
            class="d-inline-block"
            style="width: 75px;"
            :state="data.item.quantity >= 1"
            :disabled="busy"
          />
          <span v-if="data.item.quantity === null" class="ml-2">1</span>
        </template>
        <template v-slot:cell(discount)="data">
          {{ numeral(-data.value).format('0.00') }}
        </template>
        <template v-slot:cell(price)="data">
          <b-form-input
            v-if="data.item.can_change_price"
            v-model="data.item.price"
            size="sm"
            class="d-inline-block"
            style="width: 100px;"
            lazy-formatter
            :formatter="formatter"
            :state="priceIsValid(data.item.price)"
            :disabled="busy"
          />
          <span v-if="!data.item.can_change_price" class="ml-2">
            {{ numeral(data.item.price).format('0.00') }}
          </span>
        </template>
        <template v-slot:cell(total)="data">
          {{ numeral(calcTotal(data.item)).format('0.00') }}
        </template>
      </b-table>
    </b-overlay>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'admin-invoice-items-modal',
      },
      organization: Object,
      invoice_items: Array,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        busy: false,
        error: null,
        items: [],
      }
    },
    computed: {
      showQuantity() {
        return _.reduce(this.items, (show, item) => {
          if (item.quantity !== null) show = true
          return show
        }, false)
      },
      showDiscount() {
        return _.reduce(this.items, (show, item) => {
          if (item.discount > 0) show = true
          return show
        }, false)
      },
      fields() {
        let fields = [{
          key: 'name',
          label: trans('name')
        }]
        if (this.showQuantity) {
          fields.push({
            key: 'quantity',
            label: trans('qty'),
            thClass: 'pl-2',
            thStyle: 'width: 85px;',
          })
        }
        if (this.showDiscount) {
          fields.push({
            key: 'discount',
            label: trans('discount'),
            thClass: 'text-right',
            thStyle: 'width: 85px;',
            tdClass: 'text-right',
          })
        }
        fields.push({
          key: 'price',
          label: trans('price'),
          thClass: 'pl-2',
          thStyle: 'width: 110px;',
        })
        fields.push({
          key: 'total',
          label: trans('total'),
          thClass: 'text-right',
          thStyle: 'width: 110px;',
          tdClass: 'text-right'
        })
        return fields;
      },
      serialized() {
        return _.map(this.items, item => {
          return {
            id: item.id,
            name: item.name,
            quantity: item.quantity || 1,
            price: item.price,
          }
        })
      },
    },
    watch: {
      invoice_items() {
        this.hydrate()
      },
    },
    methods: {
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        axios.patch(`/org/${this.organization.id}/cart`, {
          invoice_items: this.serialized
        })
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      priceIsValid(price) {
        const amount = parseFloat(price)
        return !isNaN(amount) && amount >= 0
      },
      calcTotal(item) {
        return item.price * (item.quantity || 1) - (item.discount || 0)
      },
      formatter(value) {
        if (value === null || value === undefined || value === '') return ''
        return numeral(value).format('0.00')
      },
      onShown() {
        this.busy = false
        this.error = false
      },
      hydrate() {
        let addon_items = []
        this.items = _.reduce(this.invoice_items, (items, ii) => {
          let item = {
            id: ii.id,
            addon_id: ii.addon_id,
            package_id: ii.package_id,
            product_id: ii.product_id,
            invoice_item_id: ii.invoice_item_id,
            name: ii.name,
            quantity: !ii.package_id ? ii.quantity : null,
            price: parseInt(ii.price, 10),
            discount: parseInt(ii.discount, 10),
            is_addon: !!ii.addon_id,
            is_package: !!ii.package_id,
            is_product: !!ii.product_id,
            can_change_price: ii.discount == 0,
          }
          if (item.is_addon) {
            addon_items.push(item)
          } else {
            items.push(item)
          }
          return items
        }, [])
        addon_items = _.sortBy(addon_items, function(item) {
          return - item.id
        })
        _.each(addon_items, addon_item => {
          let index = _.findIndex(this.items, {id: addon_item.invoice_item_id})
          if (index >= 0) this.items.splice(index+1, 0, addon_item)
        })
      },
    },
    mounted() {
      window.adminInvoiceItemsModal = this
      this.hydrate()
    },
  }
</script>